export default "__VITE_ASSET__BydgDyrU__"